import React from 'react'
import { Typography, Button } from '@material-ui/core'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { ReactComponent as ErrorIcon } from 'app/components/icons/WarningNetworkError.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.grey.contrastText,
  },
  logoImage: {
    height: '6rem',
    width: '6rem',
  },
}))

const ErrorView = (props) => {
  const { icon, title, subtitle, action, actionText, ...rest } = props
  const classes = useStyles()

  return (
    <div
      className={clsx(
        classes.root,
        'flex flex-col items-center text-center py-64',
      )}
      {...rest}
    >
      <ErrorIcon className={clsx('mb-16', classes.logoImage)} />
      <Typography variant="h5" className="font-bold mb-8">
        {title || <FormattedMessage id="error.general.title" />}
      </Typography>
      {subtitle ? (
        <Typography variant="subtitle1">{subtitle}</Typography>
      ) : (
        <FormattedMessage
          id="error.general.subTitle"
          values={{ newline: <br /> }}
        />
      )}
      {action ? (
        <Button
          color="secondary"
          variant="contained"
          className="mt-24"
          onClick={action}
        >
          {actionText || (
            <FormattedMessage id="errorView.actionButton.tryAgain" />
          )}
        </Button>
      ) : null}
    </div>
  )
}

ErrorView.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.func,
  actionText: PropTypes.string,
}

export default ErrorView
